import './ModuleCertificates.scss';
import Subtitle from 'components/TextComps/Subtitle';
import { CertificationTest } from 'types/module';
import { CertificateCard } from 'components/CertificateCard/CertificateCard';
import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';
import { CertificateLoaderCard } from 'components/CertificateCard/CertificateLoaderCard/CertificateLoaderCard';
import { Skeleton } from '@mui/material';

type ModuleCertificatesProps = {
  certificationTests: CertificationTest[] | undefined;
  isPending: boolean;
};

export const ModuleCertificates = ({ certificationTests, isPending }: ModuleCertificatesProps) => {
  const { t } = useTranslation();

  return (
    <section className='certificates'>
      <div className='header'>
        {!isPending ? (
          <Subtitle className='title'>
            <>{t('CertificatesHeader', { ns: 'learningHub' })}</>
          </Subtitle>
        ) : (
          <Skeleton width={150} height={30} />
        )}
      </div>

      {!isPending ? (
        <Paragraph className='paragraph'>
          <>{t('CertificatesText', { ns: 'learningHub' })}</>
        </Paragraph>
      ) : (
        <Skeleton width={450} height={30} />
      )}
      {!isPending && certificationTests ? (
        <Paragraph className='paragraph'>
          <>{t('EarnYourCertificates', { ns: 'learningHub', what: certificationTests.length > 1 ? 'certificates' : 'certificate' })}</>
        </Paragraph>
      ) : (
        <Skeleton width={350} height={30} style={{ marginBottom: 20 }} />
      )}

      <div className='available-certificates'>
        {!isPending && certificationTests
          ? certificationTests.map((test, index) => (
              <CertificateCard
                key={index}
                id={test.id}
                title={test.title}
                status={test.status}
                description={test.description}
                prerequisites={test.prerequisites}
                progress={test.progress}
                badgeImageUrl={test.badgeImageUrl}
              ></CertificateCard>
            ))
          : Array.from(Array(2)).map((el, index) => <CertificateLoaderCard key={index} />)}
      </div>
    </section>
  );
};
